import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./WhyChooseSlider.css";

// Each component instance keeps its own slides to avoid cross-instance leakage

export default function WhyChooseSlider(props) {
  const [current, setCurrent] = useState(0);
  const [slides, setSlides] = useState([]);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (slides.length <= 1 || isPaused) return;
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length, isPaused]);

  // No isMobile logic used in this component

  const handleDotClick = idx => {
    setCurrent(idx);
  };

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  useEffect(() => {
    if (props.from === "dashboard") {
      if (props.userDetails?.isAuthenticated) {
        setSlides([
          {
            image1: "/dashboard-img-2-up.png",
            image2: "/dashboard-img-2.png",
          },
        ]);
      } else {
        setSlides([
          {
            image1: "",
            image2: "/IIMB.svg",
          },
          {
            image1: "",
            image2: "/StartupIndia.svg",
          },
          {
            image1: "",
            image2: "/MSME.svg",
          },
        ]);
      }
    } else {
      if (props.userDetails?.isAuthenticated) {
        setSlides([
          {
            image1: "/IIMB.svg",
          },
          {
            image1: "/StartupIndia.svg",
          },
          {
            image1: "/MSME.svg",
          },
        ]);
      } else {
        setSlides([
          {
            image1: "/slide-1.png",
          },
          {
            image1: "/IIMB4X.png",
          },
          {
            image1: "/StartupIndia4x.png",
          },
          {
            image1: "/MSME4X.png",
          },
        ]);
      }
    }
    setCurrent(0);
  }, [props.from, props.userDetails.isAuthenticated]);

  return (
    <div
      className="whychoose-slider-container request-deals--wrapper--right-section"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {!props.userDetails?.isAuthenticated && props.from === "dashboard" && (
        <img
          src="/dashboard-img-1.png"
          className="preWatch-video--wrapper-img-fst"
          alt="pre watch img "
          style={{ minWidth: "100%", marginBottom: "10px" }}
        />
      )}

      <div className="whychoose-slider-track" style={{ transform: `translateX(-${current * 100}%)` }}>
        {slides.map(slide => (
          <div className="whychoose-slide" key={`${slide.image1}-${slide.image2 || ""}`}>
            <div className="preWatch-video--wrapper">
              {slide.image1 && (
                <img src={slide.image1} className="preWatch-video--wrapper-img-fst" alt="pre watch img " />
              )}
              {/* <img src={slide.image1} className="preWatch-video--wrapper-img-fst" alt="pre watch img " /> */}
              {slide.image2 && <img src={slide.image2} alt="pre watch img " />}
            </div>
          </div>
        ))}
      </div>
      <div className="whychoose-slider-pagination">
        {slides.map((slide, idx) => (
          <button
            type="button"
            key={`dot-${slide.image1}-${slide.image2 || ""}`}
            className={`dot${idx === current ? " active" : ""}`}
            onClick={() => handleDotClick(idx)}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

WhyChooseSlider.propTypes = {
  from: PropTypes.string,
};
